'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = navigate;

/**
 * History.
 */

var h = window.history;

/**
 * Navigate to `path`.
 */

function navigate(path) {
  h.pushState(null, '', path);
  // the below is a gross hack, but without performing a "browser
  // action" (for example, pressing "back"), the `popstate` event
  // won't fire. this mimics an action so the event is triggered.
  // this should be re-thought asap, as we're adding an extra
  // item to the history state unnecessarily
  h.pushState(null, '', path);
  h.back();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9uYXZpZ2F0ZS5qcyJdLCJuYW1lcyI6WyJuYXZpZ2F0ZSIsImgiLCJ3aW5kb3ciLCJoaXN0b3J5IiwicGF0aCIsInB1c2hTdGF0ZSIsImJhY2siXSwibWFwcGluZ3MiOiI7Ozs7O2tCQVd3QkEsUTs7QUFWeEI7Ozs7QUFJQSxJQUFNQyxJQUFJQyxPQUFPQyxPQUFqQjs7QUFFQTs7OztBQUllLFNBQVNILFFBQVQsQ0FBa0JJLElBQWxCLEVBQXdCO0FBQ3JDSCxJQUFFSSxTQUFGLENBQVksSUFBWixFQUFrQixFQUFsQixFQUFzQkQsSUFBdEI7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0FILElBQUVJLFNBQUYsQ0FBWSxJQUFaLEVBQWtCLEVBQWxCLEVBQXNCRCxJQUF0QjtBQUNBSCxJQUFFSyxJQUFGO0FBQ0QiLCJmaWxlIjoibmF2aWdhdGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJcbi8qKlxuICogSGlzdG9yeS5cbiAqL1xuXG5jb25zdCBoID0gd2luZG93Lmhpc3RvcnlcblxuLyoqXG4gKiBOYXZpZ2F0ZSB0byBgcGF0aGAuXG4gKi9cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gbmF2aWdhdGUocGF0aCkge1xuICBoLnB1c2hTdGF0ZShudWxsLCAnJywgcGF0aClcbiAgLy8gdGhlIGJlbG93IGlzIGEgZ3Jvc3MgaGFjaywgYnV0IHdpdGhvdXQgcGVyZm9ybWluZyBhIFwiYnJvd3NlclxuICAvLyBhY3Rpb25cIiAoZm9yIGV4YW1wbGUsIHByZXNzaW5nIFwiYmFja1wiKSwgdGhlIGBwb3BzdGF0ZWAgZXZlbnRcbiAgLy8gd29uJ3QgZmlyZS4gdGhpcyBtaW1pY3MgYW4gYWN0aW9uIHNvIHRoZSBldmVudCBpcyB0cmlnZ2VyZWQuXG4gIC8vIHRoaXMgc2hvdWxkIGJlIHJlLXRob3VnaHQgYXNhcCwgYXMgd2UncmUgYWRkaW5nIGFuIGV4dHJhXG4gIC8vIGl0ZW0gdG8gdGhlIGhpc3Rvcnkgc3RhdGUgdW5uZWNlc3NhcmlseVxuICBoLnB1c2hTdGF0ZShudWxsLCAnJywgcGF0aClcbiAgaC5iYWNrKClcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/deku-enroute/lib/navigate.js
// module id = 574
// module chunks = 0